import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageMedicalRecordUpdateStopMail = async (medical_record_id: string, stop_mail: number) => {
  // リクエストのデータオブジェクトを作成
  const requestData: any = {
    medical_record_id: medical_record_id,
    session_code: localStorage.getItem("session_code"),
    stop_mail: stop_mail
  }

  // リクエストの送信
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record/update_stop_mail`, requestData)

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
